<template>
  <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3" id="content_screen">
    <div class="p-3 flex content-main">
      <div class="custom-full">
        <Nav activeTab="CustomerImport"/>
        <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px] mb-[80px]">

          <template v-if="vg_selectedLocation.id">
             <CustomerImport />
           
          </template>
          <p v-else class="text-center text-theme-red">Please select a location from the top left corner.</p>
        </div>
      </div>
    </div>
  </div>
</template>




<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters} from "vuex";
import Nav from './common/Nav.vue';

import CustomerImport from './customerImport/Index.vue';


export default defineComponent({
  name: "Tools",
  components: {
    Nav,
    CustomerImport,
  },



  computed: {
    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },
 
 
});

</script>